import React from 'react';
import Modal from 'react-modal';
import './CSVPopup.scss';

Modal.setAppElement('#root')

const customStyle = {
    overlay: {
        backgroundColor: 'transparent'
        // zIndex: 98,
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        padding: 'none',
        borderRadius: '10px',
        boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.5)'
    },
}

function CSVPopup({ isOpen, onRequestClose, savePeriodData, savePageData }) {
    return (
        <Modal
            isOpen={isOpen}
            style={customStyle}
            onRequestClose={onRequestClose}
            shouldCloseOnOverlayClick={false}
        >
            <div className='sumDataModal saveAsCSV'>
                <div className='msg'>
                    <p>선택 기간 전체의 데이터를 선택하시겠습니까?</p>
                </div>
                <div className='btnsArea'>
                    <button onClick={savePeriodData}>선택 기간 전체</button>
                    <button onClick={savePageData}>현재 페이지</button>
                    <button onClick={onRequestClose}>취소</button>
                </div>
            </div>
        </Modal>
    );
}

export default CSVPopup;